import { create } from "zustand"

interface AutoApproveModalStore {
  isOpen: boolean
  onOpen: (rewardId: number, childId: number) => void
  onClose: () => void
  rewardId: number | null
  childId: number | null
}

const useAutoApproveModalStore = create<AutoApproveModalStore>((set) => ({
  isOpen: false,
  onOpen: (rewardId, childId) => set({ isOpen: true, rewardId, childId }),
  onClose: () => set({ isOpen: false, rewardId: null, childId: null }),
  rewardId: null,
  childId: null,
}))

export default useAutoApproveModalStore
